export const RANGES = ['7D', '14D', '30D'] as const;

export type Range = (typeof RANGES)[number];

export const RANGE_DAYS: Record<Range, number> = { '7D': 7, '14D': 14, '30D': 30 };

// How the stat deltas are framed for each range (current window vs the one before it).
export const RANGE_COMPARE_LABEL: Record<Range, string> = {
    '7D': 'vs last week',
    '14D': 'vs last 2 weeks',
    '30D': 'vs last month',
};
